// @flow
import React, { Component } from 'react';

import Type from '../Type';
import SourceLink from '../SourceLink';
import Description from '../Description';
import { S } from '../../pages/Docs';
import type { Property } from '../../reducers/version';

type Props = Property & {
  version: string;
}

class PropertyItem extends Component<void, Props, void> {
  render() {
    const {
      props: {
        name,
        file,
        line,
        type,
        slug,
        version,
        isStatic,
        isPrivate,
        description
      }
    } = this;

    let access = () => null;

    if (isPrivate) {
      access = () => (
        <small className={`fr pa1 br1 bg-medium ${S.flag}`}>
          Private
        </small>
      );
    }

    return (
      <li className="pv4 bb" id={slug}>
        <div className="cf mb2">
          <h4 className="fl mv0">
            <a className="fw6 mr2" href={`#${slug}`}>
              {`${isStatic ? '.' : '#'}${name}`}:
            </a>
            <Type name={type} version={version} />
          </h4>
          {access()}
        </div>
        <SourceLink file={file} line={line} />
        <Description className="pt3" content={description} />
      </li>
    );
  }
}

export default PropertyItem;



// WEBPACK FOOTER //
// ./src/components/PropertyItem/index.jsx